import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useNewTrialState } from "../../pages/new-trail/hooks/NewTrialStateProvider";
import SoilAnalysisDrawer from "./SoilAnalysisDrawer";
import { formatTranslation } from "../utils/translationUtils";
import { Drawer } from "antd";

interface SoilLayerComponentProps {
  readonly closeDrawer: () => void;
}

export function SoilLayerComponent({
  closeDrawer,
}: SoilLayerComponentProps): JSX.Element {
  const { setSoilOperationsData } = useNewTrialState();
  const { t } = useTranslation();

  const handleSelectsImage = (imageData: any): void => {
    setSoilOperationsData(imageData);
  };
  return (
    <div
      className="soil-analysis-drawer-main field-operations-container"
      data-testid="soil-analysis-drawer"
    >
      <ErrorBoundary
        fallback={
          <span>{formatTranslation(t("soil.errorLoadingSoilAnalysis"))}</span>
        }
      >
        <React.Suspense fallback={formatTranslation(t("common.loading"))}>
          <SoilAnalysisDrawer
            onSelectImage={handleSelectsImage}
            onCloseDrawer={closeDrawer}
          />
        </React.Suspense>
      </ErrorBoundary>
    </div>
  );
}
